import React from 'react';
import {
  WorkingHoursEntity2,
  WorkingHoursResponse,
  WorkingHoursStatus,
} from '../../../../../../api/types/lecturers/working-hours/working-hours.type';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import dateFormat from '../../../../../../utils/date-format';
import { WorkingHoursStatusTemplate } from './status-template/Working-hours-status-template';
import { toast } from 'react-toastify';

export interface WorkingHoursHistoryDatamodel {
  data: WorkingHoursResponse;
  handleApprove: (historyItem: WorkingHoursEntity2) => any;
  handleReject: (historyItem: WorkingHoursEntity2) => any;
}

export const WorkingHoursHistory: React.FC<WorkingHoursHistoryDatamodel> = ({
  data,
  handleApprove,
  handleReject,
}) => {
  if (!data.history || data.history.length === 0) {
    return (
      <div style={{ padding: '16px', textAlign: 'right' }}>
        <p>אין היסטוריה זמינה</p>
      </div>
    );
  }

  const historyActionsTemplate = (historyItem: WorkingHoursEntity2) => {
    if (historyItem.status === WorkingHoursStatus.PendingForApproval) {
      return (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
          <Button
            icon="pi pi-check"
            className="p-button-rounded p-button-success p-button-sm"
            onClick={(e) => {
              e.stopPropagation();
              handleApprove(historyItem);
            }}
            tooltip="אישור"
          />
          <Button
            icon="pi pi-times"
            className="p-button-rounded p-button-danger p-button-sm"
            onClick={(e) => {
              e.stopPropagation();
              handleReject(historyItem);
            }}
            tooltip="דחיה"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ padding: '16px' }}>
      <h5 style={{ margin: '0 0 16px 0', textAlign: 'right' }}>
        היסטוריית שינויים
      </h5>
      <DataTable
        value={data.history}
        size="small"
        showGridlines
        tableStyle={{ direction: 'rtl' }}
      >
        <Column
          field="startAt"
          header="תאריך התחלה"
          body={(rowData: WorkingHoursEntity2) =>
            dateFormat.displayFormatDate(rowData.startAt)
          }
          style={{ textAlign: 'right' }}
        />
        <Column
          field="startAt"
          header="שעת התחלה"
          body={(rowData: WorkingHoursResponse) => (
            <label>{dateFormat.formatTimeFromDate(rowData.startAt)}</label>
          )}
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="endAt"
          header="שעת סיום"
          body={(rowData: WorkingHoursResponse) => (
            <label>{dateFormat.formatTimeFromDate(rowData.endAt)}</label>
          )}
          sortable
          style={{ textAlign: 'right' }}
        />
        <Column
          field="status"
          header="סטטוס"
          body={(rowData: WorkingHoursEntity2) =>
            WorkingHoursStatusTemplate(rowData as WorkingHoursResponse)
          }
          style={{ textAlign: 'right' }}
        />
        <Column
          field="activityType"
          header="סוג פעילות"
          body={(rowData: WorkingHoursEntity2) =>
            `סוג פעילות ${rowData.activityTypeName}`
          }
          style={{ textAlign: 'right' }}
        />
        <Column
          field="isManual"
          header="סוג"
          body={(rowData: WorkingHoursEntity2) =>
            rowData.isManual ? 'ידני' : 'אוטומטי'
          }
          style={{ textAlign: 'right' }}
        />
        <Column
          field="branchLecturersRates"
          header="תעריף"
          body={(rowData: WorkingHoursEntity2) =>
            `₪${rowData.branchLecturersRates}`
          }
          style={{ textAlign: 'right' }}
        />
        <Column
          header="פעולות"
          body={historyActionsTemplate}
          style={{ textAlign: 'center', width: '120px' }}
        />
      </DataTable>
    </div>
  );
};
